import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'agMacAddress'
})
export class AgMacAddressPipe implements PipeTransform {

    transform(value: any, ...args: any[]): any {
        if (!value) {
            return '-';
        }
        if (value.includes(':')) {
            return value;
        }
        if (args.includes('separator')) {
            const separator = args[1] || ':';
            // Add a separator
            return value.split('').reduce((previousValue, currentValue, currentIdx) => {
                if (currentIdx > 0 && currentIdx % 2 === 0) {
                    return previousValue + separator + currentValue;
                }
                else {
                    return previousValue + currentValue;
                }
            });
        }
        return value.replaceAll('-', ':');
    }

}
